var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(-1378 -156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8255",
    "data-name": "Rectangle 8255",
    width: 42,
    height: 42,
    rx: 21,
    transform: "translate(1378 156)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(1390 167.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4692",
    "data-name": "Path 4692",
    d: "M11.493,82.473,1.253,92.714a.408.408,0,0,0-.106.187L.011,97.457a.4.4,0,0,0,.391.5.4.4,0,0,0,.1-.012L5.056,96.81a.4.4,0,0,0,.187-.106l10.241-10.24Zm0,0",
    transform: "translate(0 -79.119)",
    fill: "#080808"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4693",
    "data-name": "Path 4693",
    d: "M339.715,1.958l-1.14-1.14a2.064,2.064,0,0,0-2.851,0l-1.4,1.4L338.319,6.2l1.4-1.4a2.016,2.016,0,0,0,0-2.851Zm0,0",
    transform: "translate(-321.694 0)",
    fill: "#080808"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.f7d9c672354ec95dd134e77796aba1f0.svg";
export { ForwardRef as ReactComponent };